var map = {
	"./ARB.svg": 7540,
	"./AVAX.svg": 32078,
	"./BNB.svg": 14078,
	"./BTC.svg": 10598,
	"./BUSD.svg": 19,
	"./DAI.svg": 92774,
	"./DOGE.svg": 95970,
	"./ETH.svg": 32466,
	"./FRAX.svg": 92945,
	"./LINK.svg": 27853,
	"./MATIC.svg": 6646,
	"./SOL.svg": 66058,
	"./USDC.svg": 43100,
	"./USDT.svg": 95306,
	"./WBTC.svg": 41584,
	"./WETH.svg": 13139,
	"./XRP.svg": 54925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18090;